import request from '@/utils/request'
const baseURL = process.env.NODE_ENV === 'production' ? 'https://zhihuishu-livecourse-desktop.zhihuishu.com/' : '/msc2'

/**
 * @description: 各个终端,服务,从状态机中获取直播相关数据
 * @param {*} params
 * @return {*}
 */
const getLiveInfoGlobalMSC2 = params => {
  return request({
    baseURL,
    url: `/livecourse-desktop/live/v2/detail`,
    method: 'post',
    params
  })
}

export default {
  getLiveInfoGlobalMSC2
}
